import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('PromptingExercise', LATEST_SCHEMA_VERSION.PromptingExercise);
export default exerciseTypeVersionAdapter;